import { useFormContext } from 'react-hook-form'
import { Form } from '../../..'
import { PosProfilePosInventoryFeaturesEnum } from '../../../../../../generated/graphql'
import { t } from 'i18next'
import { ConditionalDialogInput } from '../../../../../../inputs/conditional-dialog-input'

export const LimitPosInventoryFeaturesField = () => {
  const { control } = useFormContext<Form>()

  return (
    <ConditionalDialogInput
      label={t('pos_profiles:pos_options_section.pos_inventory_features_label')}
      control={control}
      name="pos_inventory_features"
      dialogInputProps={{
        options: Object.keys(PosProfilePosInventoryFeaturesEnum),
        formatValue: (value) => ({
          value: value,
          label: t(
            `pos_profiles:pos_options_section.inventory_features_options.${value}`,
          ),
        }),
        addLabel: t('pos_profiles:pos_options_section.add_feature'),
        itemLabel: t(
          'pos_profiles:pos_options_section.limit_pos_inventory_features_label',
        ),
        emptyMessage: t(
          'pos_profiles:pos_options_section.pos_inventory_features_empty',
        ),
      }}
    />
  )
}
